import Cookies from 'js-cookie'

const TokenKey = 'vue_admin_template_token'
const UidKey = 'vue_admin_template_uid'
const EasemobNameKey = 'vue_admin_template_easemob_name'
const EasemobPwdKey = 'vue_admin_template_easemob_pwd'

const VisitorUser = 'vue_visitor_user'

export function setTokenType(type) {
  //1 平台登录， 2 游客查询数据
  return Cookies.set("TokenType", type)
}
export function getTokenType() {
  //1 平台登录， 2 游客查询数据
  return Cookies.get("TokenType")
}

export function setVisitorUser(data) {
  return Cookies.set(VisitorUser, data)
}
export function getVisitorUser() {
  return Cookies.get(VisitorUser)
}
export function removeVisitorUser() {
  return Cookies.remove(VisitorUser)
}

export function getToken() {
  return Cookies.get(TokenKey)
}
export function setToken(token) {
  return Cookies.set(TokenKey, token)
}
export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getUid() {
  return Cookies.get(UidKey)
}
export function setUid(uid) {
  return Cookies.set(UidKey, uid)
}
export function removeUid() {
  return Cookies.remove(UidKey)
}

export function getEasemobName() {
  return Cookies.get(EasemobNameKey)
}
export function setEasemobName(value) {
  return Cookies.set(EasemobNameKey, value)
}
export function removeEasemobName() {
  return Cookies.remove(EasemobNameKey)
}

export function getEasemobPwd() {
  return Cookies.get(EasemobPwdKey)
}
export function setEasemobPwd(value) {
  return Cookies.set(EasemobPwdKey, value)
}
export function removeEasemobPwd() {
  return Cookies.remove(EasemobPwdKey)
}

// 聊天（webman/push）用户名：拼鉴权地址时当 chat_username 用
// 注：频道名和聊天身份 id 不在这里存 Cookie，统一由 utils/webman-push.js 的
// pushConfig（sessionStorage）持有，见 getPushChannel() / getPushChatUid()
const ChatUsernameKey = 'chatUsername'

export function getChatUsername() {
  return Cookies.get(ChatUsernameKey)
}
export function setChatUsername(value) {
  return Cookies.set(ChatUsernameKey, value)
}
export function removeChatUsername() {
  return Cookies.remove(ChatUsernameKey)
}

// 该管理员是否可接待在线咨询（登录返回的 chat_can_service，true/false）
// 只有为 true 时 router 守卫才建立 webman/push 连接
const ChatCanServiceKey = 'chatCanService'

export function getChatCanService() {
  // Cookie 里存的是字符串，这里转回布尔，调用方不用自己比 'true'
  return Cookies.get(ChatCanServiceKey) === 'true'
}
export function setChatCanService(value) {
  return Cookies.set(ChatCanServiceKey, value ? 'true' : 'false')
}

export function setRoles(rolesData) {
  let tempArr = []
  if (rolesData) {
    JSON.parse(rolesData).map(item => {
      tempArr = tempArr.concat(item.checkedRoles)
    })
    return Cookies.set('roles', JSON.stringify(tempArr))
  } else {
    return Cookies.set('roles', rolesData)
  }
}

export function setUserName(name) {
  return Cookies.set('username', name)
}
export function getUserName() {
  return Cookies.get('username')
}

export function setUserAvatar(avatar) {
  return Cookies.set('useravatar', avatar)
}

export function getUserAvatar() {
  return Cookies.get('useravatar')
}

export function setServiceRoles(roles) {
  return Cookies.set('serviceRoles', roles)
}
export function getServiceRoles() {
  return Cookies.get('serviceRoles')
}
export function removetServiceRoles() {
  return Cookies.remove('serviceRoles')
}

export function setServiceID(id) {
  return Cookies.set('serviceId', id)
}
export function getServiceID() {
  return Cookies.get('serviceId')
}
export function removeServiceID(id) {
  return Cookies.remove('serviceId')
}
export function setIsAppoint(appoint) {
  return Cookies.set('isAppoint', appoint)
}
export function getIsAppoint() {
  return Cookies.get('isAppoint')
}
export function setRolesName(appoint) {
  return Cookies.set('rolename', appoint)
}
export function getRolesName() {
  return Cookies.get('rolename')
}
